import PropTypes from "prop-types";
import React from "react";

const LAYOUTS = [
    { value: "grid two-column", icon: "fa fa-th-large", label: "Two columns" },
    { value: "grid three-column", icon: "fa fa-th", label: "Three columns" },
    { value: "list", icon: "fa fa-list-ul", label: "List" },
];

// The active layout comes from state, so the default (three columns) shows as active on
// load instead of only after the first click.
const ShopTopAction = ({ layout, getLayout, getFilterSortParams, productCount, sortedProductCount }) => {
    return (
        <div className="shop-top-bar mb-35">
            <div className="select-shoing-wrap">
                <div className="shop-select">
                    <select onChange={(e) => getFilterSortParams("filterSort", e.target.value)}>
                        <option value="default">Default</option>
                        <option value="priceHighToLow">Price - High to Low</option>
                        <option value="priceLowToHigh">Price - Low to High</option>
                    </select>
                </div>
                <p>
                    Showing {sortedProductCount} of {productCount} result
                </p>
            </div>

            <div className="shop-tab">
                {LAYOUTS.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        className={layout === option.value ? "active" : ""}
                        aria-label={option.label}
                        aria-pressed={layout === option.value}
                        onClick={() => getLayout(option.value)}
                    >
                        <i className={option.icon} />
                    </button>
                ))}
            </div>
        </div>
    );
};

ShopTopAction.propTypes = {
    getFilterSortParams: PropTypes.func,
    getLayout: PropTypes.func,
    layout: PropTypes.string,
    productCount: PropTypes.number,
    sortedProductCount: PropTypes.number,
};

export default ShopTopAction;